import { useState, useEffect } from "react";
import Message from "../../components/Message";
import Box from "../../components/Box";
import ColorCheckbox from "../../components/ColorCheckbox";

import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { setProductVariants } from "../../designer/store/slices/productSlice";
import ColorSwatches from "../../components/ColorSwatches";

// const colorSwatches = [
//   { name: "Black Heather", preview: variant1img, fullImage: variant1img },
//   { name: "Cardinal", preview: variant2img, fullImage: variant2img },
//   { name: "Brown", preview: variant3img, fullImage: variant3img },
//   { name: "Heather Forest", preview: variant4img, fullImage: variant4img },
//   { name: "Red", preview: variant5img, fullImage: variant5img },
// ];

const ProductColors = ({ product, previews }: any) => {
  const availableColors = product?.map((i: any) => i.option1);
  const availableSizes = product
  ?.map((i: any) => i.option2).filter((size:any) => size !== null && size !== '');
  // const availableSizes = ["XS", "S", "M", "L", "XXL", "XXXL"];

  const [colors, setColors] = useState<any>([]);
  const [sizes, setSizes] = useState<any>([]);
  const [selectedVariant, setSelectedVariant] = useState<any>([]);

  const dispatch = useAppDispatch();
  const productOption2: any = useAppSelector(
    (state: any) => state.product.product_colors.catalogproductvariants
  );

  const handleChangeColor = (color: any) => {
   
    let find_variant=productOption2.find((ft:any)=>ft.option1==color);
    console.log("colorrrrr",color);
    console.log("find_variant____" ,find_variant);
    const newColors = [...colors];
    const newVar = [...selectedVariant];
    const hasColor = colors.some((item: any) => item === color);
    const hasVariant = selectedVariant.some((item: any) => item.id === find_variant.id);
    if (hasColor) {
      let index = newColors.indexOf(color);
      if (index !== -1) {
        newColors.splice(index, 1);
      }
    } else {
      newColors.push(color);
    }
    if (hasVariant) {
      let index = newVar.indexOf(find_variant);
      if (index !== -1) {
        newVar.splice(index, 1);
      }
    } else {
      newVar.push(find_variant);
    }
console.log("newVar__________" , newVar);
setSelectedVariant(newVar);
    dispatch(setProductVariants(newVar));
    // dispatch(setProductVariants(newColors));
    setColors(newColors);
  };

  const handleSelectAllColors = (e: any) => {
    const checked = e.target.checked;
    if (checked) {
      setColors(availableColors);
      dispatch(setProductVariants(productOption2));
    } else {
      dispatch(setProductVariants([]));
      setColors([]);
    }
  };

  const handleChangeSize = (size: any) => {
    const newSizes = [...sizes];
    const hasSize = sizes.some((item: any) => item === size);
    if (hasSize) {
      let index = newSizes.indexOf(size);
      if (index !== -1) {
        newSizes.splice(index, 1);
      }
    } else {
      newSizes.push(size);
    }
    setSizes(newSizes);
  };

  const handleSelectAllSizes = (e: any) => {
    const checked = e.target.checked;
    if (checked) {
      setSizes(availableSizes);
    } else {
      setSizes([]);
    }
  };
  const renderColor = () => {
    return (
      <>
        <div className="mb-5">
          <div className="font-bold text-gray-600 mb-2">Choose colors:</div>
          <label className="flex items-center gap-1">
            <input
              className="w-4 h-4"
              type="checkbox"
              name="colors"
              onChange={handleSelectAllColors}
            />{" "}
            Select all colors
          </label>
          <div className="flex gap-2 mt-3">
            {availableColors.map((item: any) => (
              <ColorCheckbox
                key={item}
                color={item}
                checked={colors.some((i: any) => i === item)}
                onChange={() => handleChangeColor(item)}
              />
            ))}
          </div>
        </div>
      </>
    );
  };

  const renderSize = () => {
    console.log("availableSizes____" , availableSizes);
    
    if(availableSizes && availableSizes.length>0){
      return (
        <div className="mb-5">
          <div className="font-bold text-gray-600 mb-2">Choose sizes:</div>
          <label className="flex items-center gap-1 mb-2">
            <input
              className="w-4 h-4"
              type="checkbox"
              name="sizes"
              onChange={handleSelectAllSizes}
            />{" "}
            Select all sizes
          </label>
          <div className="flex gap-3">
            {availableSizes.map((item: any) => (
              <label
                className="flex items-center gap-1"
                key={item}
                htmlFor={item}
              >
                <input
                  className="w-4 h-4"
                  type="checkbox"
                  name={item}
                  id={item}
                  checked={sizes.some((i: any) => i === item)}
                  onChange={() => handleChangeSize(item)}
                />{" "}
                {item.toUpperCase()}
              </label>
            ))}
          </div>
        </div>
      );
    }
    else{
      return(
        <>
        </>
      )
    }
   
  };

  useEffect(() => {
    console.log("productOption2_______::" , productOption2);
    
    if (productOption2 && productOption2.length > 0) {
      productOption2.forEach((value: any, index: any) => {
        if (typeof value === "object" && value !== null && "Name" in value) {
          const optionObject = value as {
            Name: string;
            optionId: string;
            catalogoptionsvalues: any;
          };
          let colors_data = optionObject.catalogoptionsvalues;
          const colorsValue: string = colors_data[0]?.value || "";
          const option_value: string[] = colorsValue.split(",");
          if (optionObject.Name === "Color") {
            setColors(option_value);
            console.log("color_option_value", option_value);
          }
          if (optionObject.Name === "Size") {
            setSizes(option_value);
            console.log("Size_option_value", option_value);
          }
        }
      });
    }
  }, []);

  return (
    <Box>
      <div className="flex max-md:flex-col items-stretch justify-between gap-5">
        <div className="w-full max-w-[350px] pr-5 border-r max-md:border-r-0 max-md:border-b pb-3 border-solid border-gray-200">
          <h3>Product Variants</h3>
          <br />
          <p>Select All desired Product Variants to sell on store</p>
        </div>
        <div className="w-full">
          <div className="mb-5">
            <ColorSwatches swatches={previews} />
          </div>
          {availableColors && renderColor()}
          {availableSizes && renderSize()}
          <div className="mb-5">
            <p className="text-[15px] mb-2">
              Out of stock variant fulfillment times
            </p>
            <Message type="warning">
              Some of your product variants are currently out of stock. You can
              add them to your store, but if they’re ordered, fulfillment could
              take 2–4 weeks.
            </Message>
          </div>
          <div className="flex items-start gap-5">
            {sizes && sizes.length > 0 && (
              <div className="min-w-[120px]">
                <p className="text-[15px] mb-1">Size</p>
                {sizes.map((item: any) => (
                  <p className="inline-block mr-2" key={item}>
                    {item.toUpperCase()}
                  </p>
                ))}
              </div>
            )}
            {colors && colors.length > 0 && (
              <div>
                <p className="text-[15px] mb-1">Colors</p>
                <div>
                  {colors.map((item: any) => (
                    <div
                      key={item}
                      className="w-4 h-4 inline-block m-0.5 rounded-sm border border-solid border-gray-500"
                      style={{ backgroundColor: item }}
                    ></div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Box>
  );
};

export default ProductColors;
